<template>
  <div class="customer-po-open__list-rfq-3">
    <list-form
      ref="list-form"
      :config="config"
      :formModel="formModel"
      @onGet="handlerGet"
      @onChangeDataOrigin="handleChangeDataOrigin"
    >
      <template v-slot:title="{ title }">
        <h3 class="blue-text">{{title}}</h3>
      </template>
      <template v-slot="{ data, updateDataItem, autoSave, handleCommand }">
        <edit-form
          :disabled="disabled"
          :data="data"
          :model="formModel"
          :isNew="false"
          :config="{ id: config.id }"
          @change="updateDataItem($event)"
          @onAutoSave="autoSave"
          @command="handleCommand"
        />
      </template>
    </list-form>
    <button-line
      v-if="showButton && !disabled"
      :disabled="disabledNext"
      @click="handlerClick"
    >
      {{L10n('create-po')}}
    </button-line>
  </div>
</template>

<script>
import listFormConfig from './ListFormConfig.json'
import { waitValue } from '@/utils/promises.js'
import { MainModel } from '@/models/RFQ3.js'
export default {
  name: 'ListFormCustomerPoOpen',
  components: {
    'button-line': () => import(/* webpackChunkName: 'UI' */ '@/components/UI/ButtonLine.vue'),
    'list-form': () => import(/* webpackChunkName: 'ListForm' */ '@/components/ListForm/Index'),
    'edit-form': () => import(/* webpackChunkName: 'Shared' */ './FormRFQ3.vue')
  },
  props: {
    disabled: { type: Boolean, default: false },
    moduleName: { type: String, required: true },
    data: { type: Object, required: true },
    isValid: { type: Boolean, required: true },
    eventID: { type: String, required: true },
    showButton: { type: Boolean, default: false }
  },
  created () {
    this.$bus.$on(`refresh-data-${this.eventID}`, this.loadData)
  },
  beforeDestroy () {
    this.$bus.$off(`refresh-data-${this.eventID}`, this.loadData)
  },
  watch: {
    disabledNext: {
      handler (value) {
        if (value) {
          this.$emit('command', 'hide-po')
        }
      }
    },
    'data.rfqid': {
      immediate: true,
      handler (value) {
        this.loadData()
      }
    }
  },
  data () {
    listFormConfig.id = `${this.moduleName}-list-rfq3`
    return {
      disabledNext: true,
      config: listFormConfig
    }
  },
  methods: {
    checkIsValid (dataList) {
      let requiredFields = [
        'partID', 'qty', 'partSN', 'price', 'currencyID', 'conditionID'
      ]
      const list = dataList
        .filter(({ chosen }) => chosen)
      return list.length > 0 && list
        .every((quote) => {
          return requiredFields.every((field) => !!quote[field])
        })
    },
    handlerClick () {
      if (this.disabledNext) return
      this.$emit('command', 'show-po')
    },
    getListForm () {
      return waitValue(() => this.$refs['list-form'])
    },
    updateDataListRFQ3 (data) {
      this.$store.commit(`${this.moduleName}/SET`, { key: 'listRFQ3', value: data })
    },
    handleChangeDataOrigin (data) {
      this.validate()
      this.updateDataListRFQ3(data)
    },
    handlerGet () {
      this.$nextTick(() => {
        this.$emit('command', 'came-list-rfq-3')
      })
    },
    validate () {
      this.getListForm()
        .then((listForm) => {
          let dataList = listForm.getData()
          this.disabledNext = !this.checkIsValid(dataList)
          this.$emit('update:isValid', !this.disabledNext)
        })
    },
    formModel () {
      return this.copyObjectProps(new MainModel(), {
        rfqid: this.data.rfqid
      })
    },
    loadData () {
      this.getListForm()
        .then((listForm) => {
          if (!this.data.rfqid) return
          let filters = `rfqid == "${this.data.rfqid}"`
          listForm.setFilters(filters)
          listForm.loadData()
        })
    }
  }
}
</script>
<style lang="stylus">
  .customer-po-open__list-rfq-3{
    .list-form__header{
      padding-left 0
      padding-right 0
    }
  }
</style>
